import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import Button from 'srcReact/components/common2/Button'
import { commonConstants as cc } from 'srcReact/components'
import styles from './styles.module.scss'
import { messengerActions } from 'srcReact/MessengerPage'
import Spinner from 'srcReact/components/common2/Spinner'

export default function DeleteMessageConfirmation({ message }) {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const {
    common: { isMobile },
    messenger: { loading, isMessageDeleted },
  } = useSelector((state) => state)
  const [deleteConfirmed, setDeleteConfirmed] = useState(false)

  const close = () => {
    dispatch({ type: cc.POPIN_CLOSE })
  }

  const deleteMessage = () => {
    if (message) {
      dispatch(messengerActions.deleteMessage(message.id))
      setDeleteConfirmed(true)
    }
  }
  useEffect(() => {
    if (isMessageDeleted && deleteConfirmed) {
      close()
    }
  }, [isMessageDeleted])

  return (
    <div className={styles.container}>
      <h1 className={styles.title}>{t('messenger.chatWindow.deleteMessageConfirmationTitle')}</h1>
      <h2 className={styles.warning}>{t('messenger.chatWindow.deleteMessageConfirmationWarning')}</h2>
      <div className={styles.buttonWrapper}>
        <Button
          size='large'
          handleClick={close}
          style='tertiary'
          text={isMobile ? t('messenger.no') : t('messenger.btnCancel')}
        />
        <Button
          size='large'
          text={
            loading ? (
              <Spinner isWhite={true} customCss={styles.spinner} />
            ) : isMobile ? (
              t('messenger.yes')
            ) : (
              t('messenger.btnDoIt')
            )
          }
          handleClick={deleteMessage}
        />
      </div>
    </div>
  )
}
